import { CartLinesUpdateEvent } from '@shopify/events';

/**
 * Cart bridge for the Build Your Own Clicker builder.
 *
 * The builder's own logic (shapes, key slots, caps, extras, pricing, line-item
 * properties) is unchanged from the live store. This module only replaces the
 * old theme's cart refresh with Horizon's cart event, so the drawer, cart page
 * and header bubble update exactly like a normal add to cart.
 *
 * @param {Array<{id: number, quantity: number, properties?: object}>} items
 * @returns {Promise<object>} the /cart/add.js response (with `status` on error)
 */
const routes = () => {
  const themeRoutes = typeof Theme !== 'undefined' && Theme && Theme.routes ? Theme.routes : {};
  return {
    add: themeRoutes.cart_add_url || '/cart/add.js',
    cart: themeRoutes.cart_url || '/cart',
  };
};

window.pwByoAdd = function pwByoAdd(items) {
  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((element) => (element instanceof HTMLElement ? element.dataset.sectionId : ''))
    .filter(Boolean);
  const itemCount = items.reduce((total, item) => total + (item.quantity || 0), 0);
  const deferred = CartLinesUpdateEvent.createPromise();

  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: items.map((item) => ({ merchandiseId: String(item.id), quantity: item.quantity })),
      promise: deferred.promise,
    })
  );

  return fetch(routes().add, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items, sections: sectionIds.join(',') }),
  })
    .then((response) => response.json())
    .then(async (response) => {
      if (response.status) {
        deferred.reject(new Error(response.description || response.message || 'Add to cart failed'));
        return response;
      }
      const ajaxCart = await fetch(`${routes().cart}.js`, {
        headers: { Accept: 'application/json' },
      }).then((cartResponse) => cartResponse.json());
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
        detail: {
          items: ajaxCart.items,
          source: 'pw-clicker-builder',
          sourceId: 'pw-clicker-builder',
          itemCount,
          sections: response.sections,
          didError: false,
        },
      });
      return response;
    })
    .catch((error) => {
      deferred.reject(error);
      throw error;
    });
};
